import React, { FC } from 'react'

import { IconVCarProps } from './IconVCar.types'
import * as Styled from './styles/IconVCar.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVCar: FC<IconVCarProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVCarProps['size'],
  isResponsive = false,
}: IconVCarProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#1b2f77d1-9757-43aa-a02c-99b9520fb0d3__a)' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'>
          <path
            d='M42.98 30.595a2.577 2.577 0 0 1-2.575 2.575h-1.48a5 5 0 1 0-9.82 0h-10.25a5 5 0 1 0-9.822-.008 4.327 4.327 0 0 1-4.06-4.317 7.672 7.672 0 0 1 7.675-7.675h18.037c8.268 0 12.295 4.217 12.295 9.425Z'
            stroke='#0D0D0D'
          />
          <path d='M6.62 24.105C8.355 21.167 12 13.17 20.522 13.17c6.25 0 9.5 2.43 14.406 8.43' stroke='#0D0D0D' />
          <path d='M18.953 32.233a5 5 0 0 1-9.912.938 5 5 0 1 1 9.912-.938Zm20.062 0a5 5 0 0 1-10 0 5 5 0 0 1 10 0Z' stroke='#E60000' />
        </g>
        <defs>
          <clipPath id='1b2f77d1-9757-43aa-a02c-99b9520fb0d3__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVCar
